import React, { useEffect } from 'react';
import cn from 'classnames';
import SearchInput from 'components/search/SearchInput';
import PopularSearches from 'components/search/PopularSearches';
import { useSearch } from 'utils/search';
import * as styles from './SearchMenu.module.scss';

export default function SearchMenu({ visible, handleCloseMenu }) {
  const {
    search,
    showList,
    handleSearch,
    handleKeyDown,
    handleItemClick,
    clearSearch,
    suggestions,
  } = useSearch({ insideMenu: true });

  useEffect(() => {
    if (!visible) {
      clearSearch();
    }
  }, [visible]);

  const preparedHandleItemClick = value => {
    handleItemClick(value);
    handleCloseMenu();
  };

  const preparedHandleKeyDown = e => {
    if (search.length > 0 && e.key === 'Enter') {
      handleKeyDown(e);
      handleCloseMenu();
    }
  };

  return (
    <div
      className={cn(styles.searchMenu, visible && styles.visible)}
      aria-hidden={!visible}
      inert={!visible ? true : undefined}
    >
      <div className={styles.layout}>
        <SearchInput
          className={styles.searchInput}
          search={search}
          showList={showList}
          results={suggestions}
          clearSearch={clearSearch}
          handleSearch={handleSearch}
          handleItemClick={preparedHandleItemClick}
          handleKeyDown={preparedHandleKeyDown}
        />
        <PopularSearches handleTagClick={preparedHandleItemClick} />
      </div>
    </div>
  );
}
